module.exports = __webpack_public_path__ + "17ad3b3c138e549f082555a3bbc8dfa7.svg";